"use strict";

import Dom from "common/Dom";
export const scrollToAnchorLink = function scrollToAnchorLink($this) {
  var headerHeight = $(Dom.header).outerHeight();
  var anchor = $this.attr("data-anchor-link");
  $("html,body").animate(
    {
      scrollTop: $(anchor).offset().top - headerHeight,
    },
    500,
  );
};
